import { providers } from '../../mocks/providers';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import { useState, useEffect } from 'react';

export default function ProvidersPage() {
  const [onlineCount, setOnlineCount] = useState(12847);

  useEffect(() => {
    const interval = setInterval(() => {
      setOnlineCount(prev => prev + Math.floor(Math.random() * 20) - 10);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -100px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-fade-in-up');
        }
      });
    }, observerOptions);

    document.querySelectorAll('.animate-on-scroll').forEach(el => {
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#0a0a0f] via-[#1a1a1f] to-[#0a0a0f] text-white">
      <Header onlineCount={onlineCount} />
      
      <section className="pt-32 pb-20 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16 animate-on-scroll opacity-0">
            <h1 className="text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-[#d4af37] via-[#f4d03f] to-[#d4af37] bg-clip-text text-transparent">
              Провайдеры live-игр: детальный обзор
            </h1>
            <p className="text-lg md:text-xl text-gray-300 max-w-4xl mx-auto leading-relaxed">
              Узнайте всё о ведущих разработчиках игр с живыми дилерами. Сравните их уникальные игры, 
              качество трансляций и особенности студий.
            </p>
          </div>

          {/* Provider Cards */}
          <div className="space-y-12">
            {providers.map((provider, index) => (
              <div 
                key={provider.id} 
                className="bg-[#242429] rounded-3xl overflow-hidden hover:shadow-2xl hover:shadow-[#d4af37]/20 transition-all duration-300 animate-on-scroll opacity-0"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="relative h-80">
                  <img 
                    src={provider.background} 
                    alt={provider.name} 
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent"></div>
                  <div className="absolute top-8 left-8">
                    <img src={provider.logo} alt={provider.name} className="h-16 object-contain" />
                  </div>
                  <div className="absolute bottom-8 left-8 right-8">
                    <h2 className="text-4xl font-bold mb-3">{provider.name}</h2>
                    <p className="text-xl text-gray-300">{provider.description}</p>
                  </div>
                </div>

                <div className="p-8">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
                    <div>
                      <h3 className="text-2xl font-bold mb-4 flex items-center gap-2">
                        <i className="ri-gamepad-line text-[#d4af37]"></i>
                        Топ-игры
                      </h3>
                      <div className="flex flex-wrap gap-2">
                        {provider.topGames.map((game, idx) => (
                          <span 
                            key={idx} 
                            className="bg-gradient-to-r from-[#d4af37]/20 to-[#f4d03f]/20 border border-[#d4af37] px-4 py-2 rounded-full text-sm"
                          >
                            {game}
                          </span>
                        ))}
                      </div>
                    </div>

                    <div>
                      <h3 className="text-2xl font-bold mb-4 flex items-center gap-2">
                        <i className="ri-star-line text-[#d4af37]"></i>
                        Особенности
                      </h3>
                      <ul className="space-y-2">
                        {provider.features.map((feature, idx) => (
                          <li key={idx} className="flex items-center gap-2 text-gray-300">
                            <i className="ri-check-line text-[#2ecc71]"></i>
                            {feature}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>

                  <div className="grid grid-cols-2 md:grid-cols-4 gap-4 pt-8 border-t border-gray-700">
                    <div className="text-center">
                      <div className="text-3xl font-bold text-[#d4af37] mb-1">{provider.founded}</div>
                      <div className="text-sm text-gray-400">Год основания</div>
                    </div>
                    <div className="text-center">
                      <div className="text-3xl font-bold text-[#2ecc71] mb-1">{provider.gamesCount}+</div>
                      <div className="text-sm text-gray-400">Live-игр</div>
                    </div>
                    <div className="text-center">
                      <div className="text-3xl font-bold text-[#f4d03f] mb-1">HD/4K</div>
                      <div className="text-sm text-gray-400">Качество</div>
                    </div>
                    <div className="text-center">
                      <div className="text-3xl font-bold text-white mb-1">24/7</div>
                      <div className="text-sm text-gray-400">Работа</div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Comparison Section */}
          <div className="mt-20 animate-on-scroll opacity-0">
            <h2 className="text-4xl font-bold mb-8 text-center">Сравнение провайдеров</h2>
            <div className="bg-[#242429] rounded-2xl p-8">
              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead>
                    <tr className="border-b border-gray-700">
                      <th className="px-4 py-4 text-left text-[#d4af37]">Провайдер</th>
                      <th className="px-4 py-4 text-center text-[#d4af37]">Год</th>
                      <th className="px-4 py-4 text-center text-[#d4af37]">Игр</th>
                      <th className="px-4 py-4 text-center text-[#d4af37]">Качество</th>
                      <th className="px-4 py-4 text-center text-[#d4af37]">Русский язык</th>
                    </tr>
                  </thead>
                  <tbody>
                    {providers.map((provider, index) => (
                      <tr key={provider.id} className={index % 2 === 0 ? 'bg-[#1a1a1f]' : ''}>
                        <td className="px-4 py-4 font-bold">{provider.name}</td>
                        <td className="px-4 py-4 text-center text-gray-300">{provider.founded}</td>
                        <td className="px-4 py-4 text-center text-gray-300">{provider.gamesCount}+</td>
                        <td className="px-4 py-4 text-center text-gray-300">HD/4K</td>
                        <td className="px-4 py-4 text-center">
                          <i className="ri-check-line text-2xl text-[#2ecc71]"></i>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* Info Cards */}
          <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-gradient-to-br from-[#242429] to-[#1a1a1f] rounded-2xl p-8 text-center border border-[#d4af37]/30 animate-on-scroll opacity-0">
              <i className="ri-live-line text-5xl text-[#d4af37] mb-4 block"></i>
              <h3 className="text-xl font-bold mb-2">Прямые трансляции</h3>
              <p className="text-gray-400">Все провайдеры используют профессиональное оборудование для трансляций в реальном времени</p>
            </div>
            <div className="bg-gradient-to-br from-[#242429] to-[#1a1a1f] rounded-2xl p-8 text-center border border-[#d4af37]/30 animate-on-scroll opacity-0" style={{ animationDelay: '100ms' }}>
              <i className="ri-shield-check-line text-5xl text-[#2ecc71] mb-4 block"></i>
              <h3 className="text-xl font-bold mb-2">Лицензированы</h3>
              <p className="text-gray-400">Все провайдеры имеют международные лицензии и сертификаты качества</p>
            </div>
            <div className="bg-gradient-to-br from-[#242429] to-[#1a1a1f] rounded-2xl p-8 text-center border border-[#d4af37]/30 animate-on-scroll opacity-0" style={{ animationDelay: '200ms' }}>
              <i className="ri-smartphone-line text-5xl text-[#f4d03f] mb-4 block"></i>
              <h3 className="text-xl font-bold mb-2">Мобильная версия</h3>
              <p className="text-gray-400">Все игры оптимизированы для мобильных устройств и планшетов</p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}